import { UseFormReturn, useController } from "react-hook-form"
import React, { ReactElement } from "react"

export type LabeledTextFieldProps = {
  name: string
  label: string | ReactElement
} & Pick<UseFormReturn<any, any>, "control"> &
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export const LabeledTextField = ({
  control,
  label,
  name,
  ...otherProps
}: LabeledTextFieldProps) => {
  const { field } = useController({
    name,
    control,
    rules: { required: true },
  })

  return (
    <>
      <label className="form-label d-flex flex-column">
        {label}
        <input className="form-control no-buttons" {...field} {...otherProps} />
      </label>
    </>
  )
}
